import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class ChecklistTemplateRepositoryService extends BaseRepositoryService<
  ModelRegistry['checklist-template']
> {
  recordName = 'checklist-template';
  implementMethods = [
    'findAll',
    'findRecord',
    'createRecord',
    'save',
    'destroyRecord',
    'peekAll',
    'unloadAll',
  ];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/checklist-template': ChecklistTemplateRepositoryService;
  }
}
